// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/search_text.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
import { LIMITS } from "./constants.js";
import { normalize_fa } from "./normalize_fa.js";
import { to_text } from "./to_text.js";

/*
 * build_search_text(version, values) -> the normalized, readable text of every
 * filled value, saved on the submission (`search_text`) so the panel search is a
 * single field match (spec §10). The search phrase goes through `normalize_fa` too.
 * Dates also add their stored ISO form, so both "1405/07" and "2026-10" find them.
 */

const as_list = (value) => (Array.isArray(value) ? value : []);

const has_own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

const build_search_text = (version, values, options = {}) => {
    if (!values || typeof values !== "object") {
        return "";
    }
    const parts = [];
    const add = (field, value) => {
        const text = to_text(value, field, options);
        if (text !== "") {
            parts.push(text);
        }
        if (field.type === "date" && typeof value === "string") {
            parts.push(value);
        }
    };

    as_list(version?.groups).forEach((group) => {
        if (group?.is_repeatable === true) {
            as_list(values[group.key]).forEach((instance) => {
                if (instance && typeof instance === "object") {
                    as_list(group.fields).forEach((field) => {
                        if (field && has_own(instance, field.key)) {
                            add(field, instance[field.key]);
                        }
                    });
                }
            });
            return;
        }
        as_list(group?.fields).forEach((field) => {
            if (field && has_own(values, field.key)) {
                add(field, values[field.key]);
            }
        });
    });

    return normalize_fa(parts.join(" ")).slice(0, LIMITS.SEARCH_TEXT_MAX);
};

export {
    build_search_text,
};
